import { render, staticRenderFns } from "./DecorDownloadForm.vue?vue&type=template&id=13b9c046&scoped=true"
import script from "./DecorDownloadForm.vue?vue&type=script&lang=js"
export * from "./DecorDownloadForm.vue?vue&type=script&lang=js"
import style0 from "./DecorDownloadForm.vue?vue&type=style&index=0&id=13b9c046&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b9c046",
  null
  
)

export default component.exports